<template>
    <div>
        <span v-if="lastSend">{{ formatDate(lastSend) }}</span>
        <span v-else>--</span>
    </div>
</template>

<script>

export default {
    name: "GroupTableTitle",
    components: { },
    data() {
        return {}
    },
    methods: {
        formatDate(raw) {
            const datetime = raw.toString().split('.')[0].split('T');
            const date = datetime[0];
            const military = datetime[1].split(':').slice(0,2);
            const time = `${((parseInt(military[0]) + 11) % 12 + 1)}:${military[1]}`;
            const ampm = parseInt(military[0]) >= 12 ? 'pm' : 'am';

            return `${date} ${time}${ampm}`;
        }
    },
    computed: {
        lastSend() {
            return this.data.latest_message ?
                this.data.latest_message.true_send_time :
                null;
        }
    },
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => {}
        },
    }
}
</script>

<style scoped>

</style>
